import { createIcon } from "../create-icon"

export const DownIcon = createIcon({
  title: "DownIcon",
  viewBox: "0 0 16 16",
  path: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.7603 5.7004C11.4568 5.41855 10.9823 5.43613 10.7004 5.73966L8 8.64779L5.29959 5.73966C5.01774 5.43613 4.54319 5.41855 4.23966 5.7004C3.93612 5.98226 3.91855 6.45681 4.2004 6.76034L7.4504 10.2603C7.59231 10.4132 7.79144 10.5 8 10.5C8.20855 10.5 8.40768 10.4132 8.54959 10.2603L11.7996 6.76034C12.0814 6.45681 12.0639 5.98226 11.7603 5.7004Z"
      fill="currentColor"
    />
  ),
})

DownIcon.displayName = "DownIcon"
